export default function (value) {
    const parts = value.split(".");
    if (parts.length > 1) {
        if (!parts[1].length) {
            return parts[0] + ".00";
        }
        return parts[0] + "." + parts[1].substring(0, 2);
    }
    return value;
}